import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserApi } from 'src/app/const/app.url';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  constructor(private http: HttpClient) { }

  resetPassword(body?: any) {
    return this.http.post<any>(UserApi.resetPassword, body)
  }

}
